import pm from "./mixins/page";
import search from "./mixins/search";
import sort from "./mixins/sort";
import filter from "./mixins/filters";
import preferences from "./mixins/preferences";
import page from "./page";
export * from "./page-new";
export * from "./feature-disabled";

export const SearchMixin = search;
export const SortMixin = sort;
export const PageMixin = pm;
export const FiltersMixin = filter;
export const PreferencesMixin = preferences;
export const Page = page;
export default page;
